import { useState } from "react";
import { Link2, Sparkles, X } from "lucide-react";

type Props = {
  workspaceId: string | null | undefined;
  hasReadyDraft: boolean;
  hasUsableConnection: boolean;
  isFreePlan: boolean;
  loading: boolean;
  onConnect: () => void;
  onUpgrade: () => void;
  upgradeLabel?: string;
};

export function DraftGuidance(props: Props) {
  const [dismissed, setDismissed] = useState<Set<string>>(() => new Set());
  const key = props.workspaceId ? `wavegen:draft-guidance:v1:${props.workspaceId}` : null;
  let storedDismissal = false;
  try { storedDismissal = !!key && localStorage.getItem(key) === "dismissed"; } catch {}
  if (!key || props.loading || !props.hasReadyDraft || storedDismissal || dismissed.has(key)) return null;
  if (props.hasUsableConnection && !props.isFreePlan) return null;
  const connect = !props.hasUsableConnection;

  return (
    <aside aria-label="Next step for your drafts" className="mb-5 flex items-start gap-3 rounded-lg border border-[oklch(var(--brand)/20%)] bg-[oklch(var(--brand)/6%)] px-4 py-3 text-sm text-foreground">
      {connect
        ? <Link2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-ink" aria-hidden="true" />
        : <Sparkles className="mt-0.5 h-5 w-5 shrink-0 text-brand-ink" aria-hidden="true" />}
      <p className="min-w-0 flex-1 leading-6">
        {connect ? <>Ready to share? <button type="button" onClick={props.onConnect} className="font-semibold text-brand-ink underline decoration-[oklch(var(--brand)/40%)] underline-offset-4 hover:decoration-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">Connect an account</button> to publish your posts.</> : <>Keep creating with more credits and watermark-free posts. <button type="button" onClick={props.onUpgrade} className="font-semibold text-brand-ink underline decoration-[oklch(var(--brand)/40%)] underline-offset-4 hover:decoration-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{props.upgradeLabel || "Upgrade"}</button></>}
      </p>
      <button type="button" aria-label="Dismiss draft guidance" className="-m-2 flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-[oklch(var(--brand)/10%)] hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" onClick={() => {
        setDismissed((current) => new Set(current).add(key));
        try { localStorage.setItem(key, "dismissed"); } catch {}
      }}><X className="h-4 w-4" aria-hidden="true" /></button>
    </aside>
  );
}
